import router from '@/router'
import tool from '@/utils/tool';
import Qs from 'qs';
import {Dialog} from 'vant';
// 路由权限配置
export default {
    nologin: {
        //未登录判断状态码 
        code: 304,
        //未登录提示信息
        message: '该操作需要登录，请先登录',
        //未登录执行动作
        action: () => {
            tool.data.remove('token')
            // 直接跳转登录
            if (router.app.$route.path.indexOf('/user') >= 0 || router.app.$route.path.indexOf('/cart') >= 0) {
                router.push({
                    path: '/user/login',
                    query: {
                        // 设置重定向路径
                        redirect: router.app.$route.path
                    }
                })
            } else {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '该操作需要登录，请先登录',
                    confirmButtonText: '好的'
                }).then(() => {
                    try {
                        console.log(router.app.$route);
                        let redirect = router.app.$route.path
                        if (router.app.$route.query) {
                            redirect = redirect + '?' + Qs.stringify(router.app.$route.query)
                        }
                        console.log(redirect);
                        router.push({
                            path: '/user/login',
                            query: {
                                // 设置重定向路径
                                redirect: encodeURI(redirect)
                            }
                        })
                    } catch (error) {
                        console.log('错误：' + error)
                    }
                }).catch(() => {

                });
            }
        }
    },
    noauth: {
        //无权限判断状态码 
        code: 305,
        //无权限提示信息
        message: '未登录，请重新登录',
        //无权限执行动作
        action: () => {
            //返回上一页
            router.go(-1)
        }
    }
}


// WEBPACK FOOTER //
// ./src/config/auth.js